var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { InputImageWrapper } from "../../../ui/Input/Input.styled";
import { InputWithLabelContainer } from "../../../game/GameContainer/GameContainer.styled";
import Input from "../../../ui/Input/Input";
import Label from "../../../ui/Label/Label";
import { useGameContext } from "../../../game/GameContext/GameContext";
import Icon from "../../../ui/Icon/Icon";
var StopWinLoss = function (_a) {
    var labelText = _a.labelText, propType = _a.propType;
    var _b = useGameContext(), inProgress = _b.inProgress, autoPlayInProgress = _b.autoPlayInProgress, autoPlayOptions = _b.autoPlayOptions, setAutoPlayOptions = _b.setAutoPlayOptions, controlPanelDisabled = _b.controlPanelDisabled;
    var isDisabled = useMemo(function () { return inProgress || autoPlayInProgress || controlPanelDisabled; }, [inProgress, autoPlayInProgress, controlPanelDisabled]);
    var updateStopValue = function (event) {
        var input = event.target.value;
        var sanitizedInput = input.replace(/[^\d]/g, ""); // Keep only numeric characters
        var value = parseInt(sanitizedInput || "0", 10);
        if (isNaN(value))
            return event.preventDefault();
        value = Math.min(Math.max(value, 0), 1000);
        setAutoPlayOptions(function (prevOptions) {
            var stopWin = prevOptions.stopWin, stopLoss = prevOptions.stopLoss;
            var delta = propType === "win" ? stopWin : stopLoss;
            switch (true) {
                case delta === value:
                    return prevOptions;
                case propType === "win":
                    return __assign(__assign({}, prevOptions), { stopWin: value });
                default:
                    return __assign(__assign({}, prevOptions), { stopLoss: value });
            }
        });
    };
    return (_jsxs(InputWithLabelContainer, { children: [_jsx(Label, { children: labelText }), _jsx(Input, { type: "number", variant: "default", value: propType === "win"
                    ? autoPlayOptions.stopWin.toString()
                    : autoPlayOptions.stopLoss.toString(), disabled: isDisabled, onChange: updateStopValue, leftContent: _jsx(InputImageWrapper, { children: _jsx(Icon, { cdn: "coins/usdt.png" }) }) })] }));
};
StopWinLoss.displayName = "StopWinLoss";
export default StopWinLoss;
//# sourceMappingURL=StopWinLoss.js.map